export default __webpack_public_path__ + "static/media/goal 1.b7f55aa3.svg";